/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IMoeAddtocollectionData } from './moe-addtocollection.data';
import { IMoeAddtocollectionProps } from './moe-addtocollection.props.autogenerated';

export interface IMoeAddtocollectionViewProps extends IMoeAddtocollectionProps<IMoeAddtocollectionData> {
    telemetry: any;
    context: any;
}

/**
 *
 * MoeAddtocollection component
 * @extends {React.PureComponent<IMoeAddtocollectionProps<IMoeAddtocollectionData>>}
 */
class MoeAddtocollection extends React.PureComponent<IMoeAddtocollectionProps<IMoeAddtocollectionData>> {
    public render(): JSX.Element | null {
        const viewProps: IMoeAddtocollectionViewProps = {
            ...this.props
        };

        return this.props.renderView(viewProps);
    }
}

export default MoeAddtocollection;
